import React, { useState } from "react";
import { useSelector } from "react-redux";
import ModalWrapperChildren from '@/views/components/Modal/ModalWrapperChildren';
import { useForm, Controller } from "react-hook-form";
import { TextField  } from '@mui/material';
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

import api from "@/services/api";
import Alert from '@/views/components/Alert/Alert';

const defaultValues = {
	name: '',
};

const ModalUploadDepartments = ({reloadDepartments, itemToEdit, setItemToEdit, showModalAddDepartment, setShowModalAddDepartment}) => {
	const { dict } = useSelector(state => state.app);
	const [ requestIsPending, setRequestIsPending ] = useState(false);

	const validationSchema = Yup.object({
		name: Yup.string().required(dict.departments.fieldRequired).trim(),
	});
	
	const { handleSubmit, control, setError, formState: { errors, isValid } } = useForm({
		resolver: yupResolver(validationSchema),
		defaultValues: itemToEdit || defaultValues,
		reValidateMode: 'onChange',
		mode: 'onChange',
	});

	const handleClose = () => {
		if (setItemToEdit) setItemToEdit(null);
		setShowModalAddDepartment(false);
	};

	const getErrors = (errors) => {
		if(errors) {
			const error = errors.map(err => err);
			if(error[0].code === "field.notUnique") {
				setError('name', {message: dict.departments.modalEdit.notUnique});
			} else {
				setError('name', error[0]);
			}
		}
	};
	
	const submit = async (data) => {
		setRequestIsPending(true);
		try {
			let res = {};
			
			if(itemToEdit) {
				res = await api.put(`/departments/${itemToEdit.id}`, data);
			} else {
				res = await api.post(`/departments`, data);
			}
		
			if(res.status === 200) {
				setShowModalAddDepartment(false);
				setItemToEdit(null);
				reloadDepartments();
			} else {
				getErrors(res.data.errors);
			}
		} catch (err) {
			getErrors(err.response.data.errors);
		} finally {
			setRequestIsPending(false);
		}
	};

	return (
		<ModalWrapperChildren 
			onClose={ handleClose }
			setModalVisible={ setShowModalAddDepartment }
			modalVisible={ showModalAddDepartment }
			onConfirm={ handleSubmit(submit) }
			closeButtonName={ dict.cancel }
			confirmButtonName={ itemToEdit ? dict.departments.modalAdd.saveChangesButton : dict.departments.modalAdd.addButton }
			disabled={ !isValid }
			requestIsPending={ requestIsPending }
			title={ itemToEdit ? dict.departments.modalEdit.title : dict.departments.modalAdd.title }
			description={ itemToEdit ? <div>{dict.departments.modalEdit.desc} <strong>{itemToEdit.name}</strong></div> :  dict.departments.modalAdd.desc }
			isLine
			fieldRequired
		>
			<label className="modal-children__required">
				{dict.departments.modalAdd.required}
			</label>
			<form>
				<label 
					className="modal-children__label"
					htmlFor='name'>
					{dict.departments.modalAdd.label}
				</label>
				<Controller
					render={ ({ field }) => <TextField 
						size='small'
						fullWidth
						placeholder={ dict.departments.modalAdd.placeholder }
						inputProps={ { maxLength: 4096 } }
						{ ...field } 
					/> }
					name={ 'name' }
					control={ control }
					errors={ errors.name }
				/>
				<p className="modal-children__error">{errors && errors.name && errors.name.message}</p>
			</form>
			<Alert
				style={ { marginTop: '15px', marginBottom: '0px' } }
				variant='warning'
				alertContent={ <><strong>{dict.departments.modalAdd.warning.part1}</strong> {dict.departments.modalAdd.warning.part2}</> }
			/>
		</ModalWrapperChildren>
	);
};

export default ModalUploadDepartments;
